<template lang="pug">
	div
		.calendario
			.calendarioTop
				.calendarioTopBlanco
					span.fa(style="flex: 1 1;font-size:2em;text-align:center;cursor:pointer;", :class="(horaInicio === 0) ? 'fa-caret-up' : 'fa-caret-down'", @click="toggleHoras")
				.calendarioTopDias
					.calendarioTopDiasDias
						div(v-for="dia in getDias", :key="dia.titulo", style="cursor:pointer", @click="verDia(dia.fecha)") {{dia.fecha.getDate()}} - {{dia.titulo}}
					//
						.calendarioTopDiasDias(style="min-height: 60px;border-top: 1px solid #f0f0f0;")
							.calendarioTopEventos
							div(v-for="dia in getDias", :key="dia.titulo")
			.calendarioHoras
				.calendarioHorasHoraCol(ref="colHoras")
					.calendarioHora(v-for="(hora, index) in new Array(24)", :key="hora", v-if="index >= horaInicio")
						| {{index}}:00
				.calendarioDiaCol(v-for="dia in getDias", :key="dia.titulo", v-on:drop="droped", v-on:dragover="overDrag", v-on:dragleave="leaveDrag")
					.capaEventosDia(:id="dia.fecha.getTime()", :key="dia.titulo")
						evento.eventoCalendario(
							v-for="(evento, index) in eventosUnDia(dia)"
							:key="evento.evento.ID_entrada",
							:draggable="true",
							:evento.sync="evento",
							@ver="verEntrada($event)",
							@actualizar="actualizar",
							:style="evento.style",
							:alto="altoDia")
					.calendarioDiaIntervalo(v-for="(hora, index) in new Array(24)", :key="index", v-if="index >= horaInicio")
						v-touch(tag="div", class="mediaHoraClass" :id="dia.fecha.getTime() + '-' + index + '-0'", @dblclick="nuevaEntrada(index, 1, dia.fecha)", v-on:press="nuevaEntrada(index, 1, dia.fecha)")
						v-touch(tag="div", class="mediaHoraClass" :id="dia.fecha.getTime() + '-' + index + '-15'", @dblclick="nuevaEntrada(index, 2, dia.fecha)", v-on:press="nuevaEntrada(index, 2, dia.fecha)")
						v-touch(tag="div", class="mediaHoraClass" :id="dia.fecha.getTime() + '-' + index + '-30'", @dblclick="nuevaEntrada(index, 3, dia.fecha)", v-on:press="nuevaEntrada(index, 3, dia.fecha)")
						v-touch(tag="div", class="mediaHoraClass" :id="dia.fecha.getTime() + '-' + index + '-45'", @dblclick="nuevaEntrada(index, 4, dia.fecha)", v-on:press="nuevaEntrada(index, 4, dia.fecha)")

</template>

<script>
import axios from 'axios'
import Evento from './evento'
export default {
	components: {
		'evento': Evento
	},
	props: ['fecha', 'dias', 'entradas'],
	data () {
		return {
			diasSemana: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
			horaInicio: 8
		}
	},

	watch: {
		entradas: function (nuevoValor) {
			console.log('Información actualizada')
			const dias = this.getDias
			for (let i = 0; i < dias.length; i++) {
				// this.eventosUnDia(dias[i])
			}
		}
	},

	computed: {
		fechaValida () {
			if (this.dias === 1) {
				return new Date(this.fecha.getTime())
			}

			const ahora = this.fecha
			const offset = (ahora.getDay() === 0) ? 6 : ahora.getDay() - 1

			const fecha = new Date(ahora.getTime())
			fecha.setDate(fecha.getDate() - offset)

			return fecha
		},
		getDias () {
			const dias = []

			const total = (typeof this.dias !== 'number' || this.dias < 1 || this.dias > 7) ? 7 : this.dias

			for (let i = 0; i < total; i++) {
				const fecha = new Date(this.fechaValida.getTime())
				fecha.setDate(fecha.getDate() + i)
				fecha.setHours(0)
				fecha.setMinutes(0)
				fecha.setSeconds(0)
				fecha.setMilliseconds(0)
				dias.push({
					fecha: fecha,
					titulo: this.diasSemana[fecha.getDay()]
				})
			}

			return dias
		},

		getHoras () {
			let date = new Date()
			date.setHours(0)
			date.setMinutes(0)
			const dia = date.getDate()

			const horas = []

			while (date.getDate() === dia) {
				horas.push({
					hora: date.getHours(),
					minutos: date.getMinutes(),
					fecha: new Date(date.getTime())
				})
				date = new Date(date.getTime() + 30 * 60000)
			}

			return horas
		},

		altoDia () {
			if (!this.$refs.colHoras) {
				return null
			}

			console.log(this.$refs.colHoras)

			return this.$refs.colHoras.offsetHeight
		}
	},

	methods: {
		actualizar () {
			this.$emit('actualizar')
		},
		leaveDrag (ev) {
			let elem = ev.srcElement
			while (elem.parentElement) {
				if (elem.className === 'mediaHoraClass') {
					elem.style.backgroundColor = 'inherit'
					ev.preventDefault()
					ev.stopPropagation()
					return
				}
				elem = elem.parentElement
			}
		},
		overDrag (ev) {
			let elem = ev.srcElement
			while (elem.parentElement) {
				if (elem.className === 'mediaHoraClass') {
					elem.style.backgroundColor = 'rgba(0,0,0,0.4)'
					ev.preventDefault()
					ev.stopPropagation()
					return
				}
				elem = elem.parentElement
			}
		},
		droped (ev) {
			ev.stopPropagation()
			ev.preventDefault()
			const evento = JSON.parse(ev.dataTransfer.getData('text/plain'))
			const dia = ev.srcElement.id.split('-')
			const fecha = new Date(parseInt(dia[0]))
			fecha.setHours(parseInt(dia[1]))
			fecha.setMinutes(parseInt(dia[2]))

			fecha.setSeconds(0)
			fecha.setMilliseconds(0)
			ev.srcElement.style.backgroundColor = 'inherit'
			// const top = ev.layerY - ev.offsetY
			const datos = {
				ID_entrada: evento.evento.ID_entrada,
				fechaIni: Math.floor(fecha.getTime() / 1000)
			}

			axios.post('/agenda-comercial/php/api/set-fecha-inicio-evento.php', datos)
				.then(() => {
					// recargamos los eventos
					this.$emit('actualizar')
				})
				.catch(e => {
					this.$store.commit('toast/danger', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		eventosUnDia (dia) {
			const eventos = []
			const inicioDia = new Date(dia.fecha.getTime())
			inicioDia.setHours(0)
			inicioDia.setMinutes(0)
			inicioDia.setSeconds(0)
			inicioDia.setMilliseconds(0)
			const inicioStr = inicioDia.getDate() + '-' + (inicioDia.getMonth() + 1) + '-' + inicioDia.getFullYear()

			const finDia = new Date(dia.fecha.getTime())
			finDia.setHours(23)
			finDia.setMinutes(59)
			finDia.setSeconds(59)
			finDia.setMilliseconds(999)
			// const finStr = finDia.getDate() + '-' + (finDia.getMonth() + 1) + '-' + finDia.getFullYear()
			const minutosDia = (24 - this.horaInicio) * 60
			for (let i = 0; i < this.entradas.length; i++) {
				// Si el evento es de día completo o abarca varios días, lo ignoramos
				const ev = this.entradas[i]
				const diaIniStr = ev.fechaIni.getDate() + '-' + (ev.fechaIni.getMonth() + 1) + '-' + ev.fechaIni.getFullYear()
				const diaFinStr = ev.fechaFin.getDate() + '-' + (ev.fechaFin.getMonth() + 1) + '-' + ev.fechaFin.getFullYear()

				if (diaIniStr === diaFinStr && diaIniStr === inicioStr) {
					// Calculamos su altura
					// El día tiene 1440 minutos

					const minutoEmpieza = ((ev.fechaIni.getHours() - this.horaInicio) * 60) + ev.fechaIni.getMinutes()
					const minutoTermina = ((ev.fechaFin.getHours() - this.horaInicio) * 60) + ev.fechaFin.getMinutes()

					const top = minutoEmpieza * 100 / minutosDia
					const altura = (minutoTermina - minutoEmpieza) * 100 / minutosDia

					const data = {
						evento: ev,
						intervalo: {
							top: top,
							altura: altura,
							coinciden: 0,
							previos: 0
						},
						dim: {
							top: top,
							left: 0,
							width: 100,
							height: altura,
							calculado: false
						},
						style: {
							top: top + 'px',
							height: altura + '%',
							width: '100%',
							left: '0'
						},
						estilo: {
							bgColor: ev.bgColor,
							color: ev.textColor
						}
					}
					eventos.push(data)
				}
			}
			// Ordenamos por fecha de inicio
			eventos.sort((a, b) => {
				if (a.evento.fechaIni < b.evento.fechaIni) {
					return -1
				} else if (a.evento.fechaIni === b.evento.fechaIni) {
					// Ordenamos de más largo a más corto
					if (a.evento.fechaFin < b.evento.fechaFin) {
						return 1
					} else if (a.evento.fechaFin === b.evento.fechaFin) {
						return 0
					} else {
						return -1
					}
				} else {
					return 1
				}
			})

			return this.posicionar(eventos)
		},

		getTopYBottom (porcentaje) {
			const totalAlto = 1671
			console.log(totalAlto)
			return porcentaje / 100 * totalAlto
		},

		posicionar (eventos) {
			/**
				Los eventos vienen ordenados por hora de inicio (menos a mayor)
				y después por duración (mayor a menor)
			 */
			for (let i = 0; i < eventos.length; i++) {
				const actual = eventos[i]
				const diaActual = actual.evento.fechaIni.getDate()
				const topActual = actual.dim.top
				const bottomActual = actual.dim.top + actual.dim.height
				let coinciden = []

				// Vamos a ver cuantos eventos empiezan dentro del intérvalo de este evento
				// Estos eventos se repartirán el ancho con este evento
				for (let o = i + 1; o < eventos.length; o++) {
					const siguiente = eventos[o]
					const diaSiguiente = siguiente.evento.fechaIni.getDate()
					const topSiguiente = siguiente.dim.top
					const coincide = (topSiguiente >= topActual && topSiguiente < bottomActual)

					if (diaActual === diaSiguiente && coincide) {
						coinciden.push(o)
					}
				}

				let anchoTotal = 100

				// Ahora vamos a ver si este intérvalo empieza dentro del tiempo de otro evento y si hay que ponerlo a la izquierda
				// de éste o a la derecha
				for (let p = 0; p < i; p++) {
					const anterior = eventos[p]
					const diaAnterior = anterior.evento.fechaIni.getDate()
					const topAnterior = anterior.dim.top
					const bottomAnterior = anterior.dim.top + anterior.dim.height
					const coincideAnterior = (topAnterior < topActual && bottomAnterior > topActual)

					if (diaActual === diaAnterior && coincideAnterior) {
						anchoTotal = (anterior.dim.left === 0) ? anterior.dim.width : anterior.dim.left
					}
				}

				// Los eventos coincidentes tendrán el mismo ancho
				const width = anchoTotal / (coinciden.length + 1)
				if (!actual.dim.calculado) {
					actual.dim.width = width
					// actual.dim.left = (!actual.dim.left) ? 0 : actual.dim.left
				}

				for (let c = 0; c < coinciden.length; c++) {
					const n = eventos[coinciden[c]]
					n.dim.width = width
					n.dim.left = width + (width * c)
					n.dim.calculado = true

					n.style = {
						top: n.dim.top + '%',
						left: n.dim.left + '%',
						width: n.dim.width + '%',
						height: n.dim.height + '%'
					}
				}

				if (coinciden.length > 0) {
					i = coinciden[coinciden.length - 1]
				}

				actual.style = {
					top: actual.dim.top + '%',
					left: actual.dim.left + '%',
					width: actual.dim.width + '%',
					height: actual.dim.height + '%'
				}
			}
			return eventos
		},

		verEntrada (entrada) {
			this.$emit('editar', {
				ID_entrada: entrada.ID_entrada,
				fecha: null,
				hora: null
			})
		},

		nuevaEntrada (hora, parte, dia) {
			const fecha = new Date(dia.getTime())
			fecha.setHours(hora)

			if (parte === 2) {
				fecha.setMinutes(30)
			}

			this.$emit('editar', {
				ID_entrada: 'nuevo',
				fecha: fecha,
				hora: fecha
			})
		},

		toggleHoras () {
			this.horaInicio = (this.horaInicio !== 0) ? 0 : 8
		},

		verDia (fecha) {
			this.$emit('verDia', fecha)
		},

		arrastraAbajo (ev) {

		}
	}
}
</script>

<style>
		.calendario {
			display: flex;
			border: 1px solid #f0f0f0;
			border-bottom: none;
			flex-direction: column;
			box-sizing: border-box;
			align-items: stretch;
		}

		.calendarioTop {
			display: flex;
			flex: 0 0 auto;
			flex-direction: row;
			border-bottom: 2px solid #e0e0e0;
		}

		.calendarioTopBlanco {
			display: flex;
			flex-wrap: nowrap;
			width: 60px;
			border-right: 1px solid #f0f0f0;
			min-width: 60px;
			align-items: center;
			text-align: center;
			align-content: center;
		}

		.calendarioTopDias {
			display: flex;
			flex: 1 1;
			align-items: stretch;
			flex-direction: column;
			min-width: 0;
		}

		.calendarioTopDiasDias {
			display: flex;
			position: relative;
			flex-direction: row;
			flex: 1 1;
			box-sizing: border-box;
			align-items: stretch;
		}

		.calendarioTopEventos {
			position: absolute;
			display: block;
			pointer-events: none;
			top: 0;
			left: 0;
			bottom: 0;
			right: 0;
			background-color: #e0e0e0;
			opacity: 0.5;
		}

		.calendarioTopDiasDias > div {
			overflow: hidden;
			flex: 1 0;
			text-overflow: ellipsis;
			white-space: nowrap;
			text-align: center;
			vertical-align: middle;
			border-right: 1px solid #f0f0f0;
			word-break: break-all;
			min-height: 15px;
			padding: 3px 3px;
			font-size: 95%;
			font-weight: bold;
		}

		.calendarioTopDiasDias > div:last-child {
			border-right: none;
		}


		.calendarioHoras {
			display: flex;
			flex-direction: row;
			flex: 1 1 auto;
			align-items: stretch;
			min-width: 0;
		}

		.calendarioHorasHoraCol {
			display: flex;
			flex-direction: column;
			width: 60px;
			border-right: 1px solid #f0f0f0;
			align-items: stretch;
			justify-content: flex-start;
		}
		.calendarioHora {
			flex: 0 0;
			text-align: center;
			padding: 5px 0;
			border-bottom: 1px solid #e0e0e0;
			min-height: 80px;
			max-height: 80px;
			box-sizing: border-box;
		}
		
		.calendarioDiaCol {
			display: flex;
			position: relative;
			flex-direction: column;
			border-right: 1px solid #f0f0f0;
			box-sizing: border-box;
			align-items: stretch;
			flex: 1 1 auto;
		}

		.calendarioDiaCol:last-child {
			border-right: none;
		}

		.calendarioDiaIntervalo {
			display: flex;
			flex-direction: column;
			flex: 1 0 auto;
			align-items: stretch;
			justify-content: stretch;
			box-sizing: border-box;
			flex-wrap: nowrap;
		}
		
		.calendarioDiaIntervalo > div {
			flex: 1 1;
		}

		.calendarioDiaIntervalo > div:hover {
			/* background-color: #999999;
			cursor: pointer; */
		}

		.calendarioDiaIntervalo > div {
			border-bottom: 1px solid #f9f9f9;
		}
		
		.calendarioDiaIntervalo > div:last-child {
			border-bottom: 1px solid #e0e0e0;
		}

		.capaEventosDia {
			position: absolute;
			pointer-events: none;
			top: 0;
			right: 0;
			left: 0;
			bottom: 0;
		}

		.capaEventosDia > div {
			position: absolute;
			display: flex;
			flex: 1 1;
			align-items: stretch;
			cursor: pointer;
			box-sizing: border-box;
			/* overflow: hidden; */
			pointer-events: all;
			border-radius: 3px;
			line-height: 15px;
			min-height: 25px;
		}
		.capaEventosDia > div > div {
			position: relative;
			/* opacity: 0.5; */
			flex: 1 1;
			align-content: stretch;
			align-items: stretch;
			margin: 1px;
			box-sizing: border-box;
			/* overflow: hidden; */
			text-overflow: ellipsis;
			border-radius: 3px;
			padding: 5px;
			line-height: 15px;
			font-size: 0.8em;
			-webkit-touch-callout: none; /* iOS Safari */
			-webkit-user-select: none; /* Safari */
			-khtml-user-select: none; /* Konqueror HTML */
			-moz-user-select: none; /* Firefox */
				-ms-user-select: none; /* Internet Explorer/Edge */
					user-select: none; /* Non-prefixed version, currently
										supported by Chrome and Opera */
			cursor: move;
		}

		.barras {
			position: absolute;
			left: 0;
			right: 0;
			text-align: center;
			color: white;
			display: none;
		}

		.capaEventosDia > div > div > .barras.bottom {
			bottom: 0;
			cursor: s-resize;
		}

		.capaEventosDia > div > div > .barras.top {
			top: 0;
			cursor: n-resize;
		}

		.capaEventosDia > div > div:hover > .barras {
			display: block;
		}

	</style>


// WEBPACK FOOTER //
// src/modulos/agenda-comercial/vue/componentes/calendario/semana.vue